(() => {
  const ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  async function refreshAndOpenCart(){
    const sections=await fetch(`${ROOT}?sections=cart-drawer`,{credentials:'same-origin'}).then(r=>r.json());
    const html=sections?.['cart-drawer'];
    if(!html)return;
    const doc=new DOMParser().parseFromString(html,'text/html');
    const fresh=doc.querySelector('#cart-drawer');
    const current=document.querySelector('#cart-drawer');
    if(fresh&&current)current.replaceWith(fresh);
    const drawer=document.querySelector('#cart-drawer');
    requestAnimationFrame(()=>{
      try{
        if(typeof drawer?.show==='function') drawer.show();
        else if(typeof drawer?.open==='function') drawer.open();
        else drawer?.setAttribute('open','');
      }catch(_){ drawer?.setAttribute('open',''); }
    });
  }

  document.addEventListener('submit',async event=>{
    const form=event.target.closest('#ReviveUniversalProductForm');
    if(!form)return;
    event.preventDefault();
    event.stopPropagation();

    const button=form.querySelector('[data-add]');
    const label=form.querySelector('[data-add-label]');
    const original=label?.textContent||'ADD TO CART';
    if(button)button.disabled=true;
    if(label)label.textContent='ADDING…';

    try{
      const data=new FormData(form);
      const response=await fetch(`${ROOT}cart/add.js`,{
        method:'POST',
        credentials:'same-origin',
        headers:{'Accept':'application/json'},
        body:data
      });
      if(!response.ok)throw new Error('Unable to add item');
      if(label)label.textContent='ADDED';
      await refreshAndOpenCart();
    }catch(err){
      if(label)label.textContent='TRY AGAIN';
      console.error(err);
    }finally{
      setTimeout(()=>{
        if(button)button.disabled=false;
        if(label)label.textContent=original;
      },700);
    }
  },true);
})();